var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-document"},_vm._l((_vm.pages),function(page){return _c('PDFPage',{key:page.pageNumber,attrs:{"page":page}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }